<template>
  <div class="auto-complete">
    <v-select v-model="input" :label="field" :options="data" :placeholder="placeholder" @input="complete" :components="{OpenIndicator}">
      <template slot="option" slot-scope="option">
        {{ option[field] }}
      </template>
    </v-select>
  </div>
</template>

<style lang="scss">
.auto-complete {
  position: relative;
  padding: 0;
}
</style>


<script>
    export default {
      name: "Autocomplete",
      props: {
        name: {
          type: String,
          required: true
        },
        value: {
          type: String,
          required: false
        },
        data: {
          type: Array,
          required: true
        },
        field: {
          type: String,
          required: true
        },
        placeholder: {
          type: String,
          required: false
        },
        callback: {
          required: true,
          type: Function
        }
      },
      methods: {
        complete(input) {
          if (input) {
            this.select(input);
          }
        },
        select(row) {
          // console.log(row);
          // set the input temporarily so the user sees something happening
          this.input = row[this.field];
          
          // apply the facet to parent scope
          this.callback(this.name, row[this.field]);
          
          // animate this?
          // set the input back to empty for the next facet
          this.input = "";
        },
        filter(row) {
          return row[this.field].toLowerCase().indexOf(this.input.toLowerCase()) != -1
        },
        focus(f) {
          this.focused = f
        }
      },

      data() {
        return {
          input: '',
          focused: false,
          OpenIndicator: {
            render: createElement => createElement('span', {class: {'toggle': true}}),
          },
        }
      },

      created() {
        this.input = this.value || ''
      }
    }
</script>
